import { type FeedFilterValues, useIntl } from '@capsicum/common';
import { useMemo, useState } from 'react';

import { LOADER_ACTIVITIES_CHIPS } from '../models';

export const useLoaderActivities = <T extends { value: FeedFilterValues }>(filterChips: Array<T>) => {
	const [currentChipIndex, setCurrentChipIndex] = useState(0);

	const { $t } = useIntl();

	const chips = useMemo(() => {
		return filterChips
			.filter(chip => LOADER_ACTIVITIES_CHIPS.includes(chip.value))
			.sort((a, b) => LOADER_ACTIVITIES_CHIPS.indexOf(a.value) - LOADER_ACTIVITIES_CHIPS.indexOf(b.value));
	}, [filterChips]);

	const currentChip = useMemo(() => {
		return (
			chips[currentChipIndex] || {
				iconStart: undefined,
				name: $t('common.loading'),
				value: 'noChipsAvailable'
			}
		);
	}, [chips, currentChipIndex, $t]);

	return { chips, currentChip, currentChipIndex, setCurrentChipIndex };
};
